module.exports = __webpack_public_path__ + "static/media/eupholidoptera_schmidti_011_APA.e1ca9e5a.mp3";